import React from "react";
import { Mic, Play, Square, Sparkles } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * Compact "voice control help" panel shown under the controls in every
 * trainer page so coaches and players know:
 *  - how to enable voice control
 *  - which commands trigger START / STOP
 *  - which words count as an answer in this module
 */
export default function VoiceHelp({ answerHintKey, supported = true }) {
  const { t } = useLanguage();
  return (
    <aside className="vls-voice-help" data-testid="voice-help">
      <header className="vls-voice-help-head">
        <Mic size={16} />
        <span>{t("voiceHelpTitle")}</span>
      </header>
      <ul className="vls-voice-help-list">
        <li>
          <Play size={14} className="vls-voice-help-icon vls-icon-cyan" />
          <span>{t("voiceCmdStart")}</span>
        </li>
        <li>
          <Square size={14} className="vls-voice-help-icon vls-icon-red" />
          <span>{t("voiceCmdStop")}</span>
        </li>
        {answerHintKey && (
          <li>
            <Sparkles
              size={14}
              className="vls-voice-help-icon vls-icon-orange"
            />
            <span>{t(answerHintKey)}</span>
          </li>
        )}
      </ul>
      {supported ? (
        <p className="vls-voice-help-tip">{t("voiceEnableHint")}</p>
      ) : (
        <p className="vls-voice-help-warn">{t("voiceNotSupported")}</p>
      )}
    </aside>
  );
}
